import { FC, forwardRef } from "react";
import { TextField } from "@material-ui/core";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input/max";
import PropTypes from "prop-types";

import "./phoneInputStyle.css";

interface PhoneIProps {
  value: string;
  helperText: string;
  name: string;
  label: string;
  error: boolean;
  onChange: any;
  onBlur: any;
  ref?: any;
  id: string;
  disabled?: boolean;
}

export const Input = forwardRef((props, ref) => {
  return <TextField inputRef={ref} variant="outlined" {...props} />;
});

const PhoneI: FC<PhoneIProps> = (props) => {
  const {
    name,
    label,
    value,
    helperText,
    error,
    onChange,
    onBlur,
    ref,
    id,
    disabled,
  } = props;

  return (
    <PhoneInput
      error={error}
      helperText={helperText}
      withCountryCallingCode
      international
      value={value}
      name={name}
      label={label}
      ref={ref}
      id={id}
      onChange={onChange}
      onBlur={onBlur}
      inputComponent={Input}
      disabled={disabled}
    />
  );
};

PhoneI.propTypes = {
  error: PropTypes.bool,
  helperText: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  ref: PropTypes.string,
  id: PropTypes.string,
  disabled: PropTypes.bool,
};

export default PhoneI;
